<template>
    <v-card  class="col-md-12 p-0  mx-auto" style="border: none!important;">
        <h6>آگهی های دسته انتخابی</h6>
        <p>توجه! :برای انتخاب آگهی موردنظر روی مربع کنار هر سطر کلیک کنید.
            <br>
            در صورتی که آگهی انتخابی شما با رنگ طوسی مشخص شده بود،فقط در صورت آزاد شدن آن، به دیوار ارسال خواهد شد.
        </p>
        <data-table
                :data="ownAds"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :pagination="paginate"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
        >
        </data-table>
    </v-card>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import {debounce} from "../../../../custom";

export default {
    name: "deafultAdsList",
    components: {CreateDefault, TitleRibbon, button, dataTableProps, createTarefe},
    props: {
        category: {
            default: ''
        },
        city: {
            default: undefined
        },
        neighborhood: {
            default: undefined
        },
        all: {
            default: false,
        },
        ladder: {
            default: false,
        }
    },
    data() {
        return {
            tarafeName: "",
            translates: [],
            ownAds: {},
            url: `${url}/default/own`,
            datas: {},
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            selectedAds: [],
            dataId: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    transform: (val) => {
                        return `<input type="checkbox" name="checkIt" data-id="${val.data.id}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.ownAds.current_page - 1;
                        row = row * this.ownAds.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    transform: (val) => {
                        return `<p>${val.data.id}</p>`
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'عنوان',
                    name: 'title',
                    transform(val) {
                        const color = {
                            "paid": 'danger',
                            "rejected": 'warning',
                            "enabled": 'success',
                            "disabled": 'secondary',
                        }
                        return `<span class="badge badge-${color[val.data.status]} mt-2">${val.data.title}</span>`
                    },
                    orderable: true,
                    searchable: true,
                },
            ],
        }
    },
    methods: {
        getDataForTable(url = this.url, query = this.tableProps) {
            $.ajax({
                url: url,
                method: "POST",
                fn: this.getDataForTable,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify(Object.assign({}, this.all ? {
                    all: "*",
                } : {
                    category: this.category,
                    city: this.city != '' ? this.city : undefined,
                    neighborhood: this.neighborhood != '' ? this.neighborhood : undefined,

                }, query)),
                success: (res) => {
                    this.ownAds = res.data;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
    },
    watch: {
        category: function () {
            this.getDataForTable()
        },
        selectedAds: {
            handler: function () {
                Bus.$emit('selectedAds', this.selectedAds);
            },
            deep: true
        },
        city: {
            handler: function (val) {
                this.ownAds = [];

                if (val !== "") {
                    this.getDataForTable();
                    this.reloadTable()
                }
            },
            deep: true
        },
        neighborhood: {
            handler: function (val) {

                this.ownAds = [];
                if (val !== "") {
                    this.getDataForTable();
                    this.reloadTable()
                }
            },
            deep: true
        },
    },
    mounted() {
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedAds = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedAds = []
            }
        });
        $(document).on('click', `input[name = 'checkIt']`, (element) => {
            if ($(element.target).is(':checked')) {
                const selectedPart = $(element.target).data('id');
                this.selectedAds.push(selectedPart);
            } else {
                $(element.target).prop('checked', false)
                this.selectedAds.splice(this.selectedAds.indexOf($(this).data('id')), 1)
            }
        });
    },
}
</script>

<style scoped>

</style>